<template>
  <el-dialog  title="转货"  :visible.sync="dialog" width="600px"  @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false" center>
    <div>
      <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini">
      <el-form-item label="新客户名称:" prop="newCustomer">
        <el-select v-model="addFrom.newCustomer"  filterable remote placeholder="请输入关键词" allow-create default-first-option
          :remote-method="xkhmcFn" value-key="custerCode" :loading="loading1">
          <el-option v-for="item in customerList" :key="item.custerCode" :label="item.custerName" :value="item"> </el-option>
        </el-select>
      </el-form-item>
       <div style="text-align: center;margin-bottom:20px">
          <el-input type="textarea" style="width: 95%;" placeholder="请输入备注信息" maxlength="200" v-model="addFrom.remark" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
      </div>
       </el-form>
    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
   </el-dialog>

</template>

<script>
import { getCustomerlistByTenant } from '@/api/soc-stock'
import { sVirtualChangeAdd } from '@/api/soc-stock-cosco'
export default {
  name: 'lookVoucher',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: true,
      addFrom: {
      },
      rules: {
        newCustomer: [{ required: true, message: '请选择新客户名称', trigger: 'blur' }]
      },
      customerList: [],
      loading1: false

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM

  },
  methods: {
    // 根据查询条件获取新客户列表
    xkhmcFn (query) {
      this.loading1 = true
      getCustomerlistByTenant({
        nameLike: query,
        tenantCode: this.rowData.goodList[0].organizationId
      }).then(res => {
        this.loading1 = false
        this.customerList = res
      })
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (typeof (this.addFrom.newCustomer) == 'string') {
            this.addFrom.newCustomerName = this.addFrom.newCustomer
            this.addFrom.newCustomerTaxId = ''
            this.addFrom.newCustomerId = ''
          } else {
            if (this.addFrom.newCustomer.custerCode == '') {
              this.addFrom.newCustomer = null
            } else {
              this.addFrom.newCustomerTaxId = this.addFrom.newCustomer.taxpayerNumber
              this.addFrom.newCustomerId = this.addFrom.newCustomer.custerCode
              this.addFrom.newCustomerName = this.addFrom.newCustomer.custerName
            }
          }
          this.addFrom.sVirtualGoods = this.rowData.goodList
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sVirtualChangeAdd(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$router.push({ path: '/ZYtransferGoodsBill' })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
</style>
